import { useQuery } from '@tanstack/react-query';
import { http } from '@lib/api';
import type { components } from '@/types/api.generated';

export type RoutePlanningStops = components['schemas']['RoutePlanningStops'];

/**
 * The geocoded stops of one shipping day (`/api/route-planning/stops`). The
 * desktop route-planning tab and the phone driver list (#2677) share this one
 * query key. Read-only.
 */
export function useRoutePlanningStops(date: string) {
  return useQuery({
    queryKey: ['route-planning', 'stops', date],
    queryFn: () =>
      http.get<RoutePlanningStops>('/api/route-planning/stops', {
        params: { date },
      }),
    enabled: date.length > 0,
    staleTime: 60_000,
  });
}
